import type { PartUpsertByPartNumberVariables } from '@jtms/default-connector';
import type { Part } from '@dis/models';

export function numberOrNull(value: unknown): number | null {
  if (value === null || value === undefined || value === '') return null;
  if (typeof value === 'number') return value;

  const cleaned = String(value).replace(/[^\d.-]/g, '');
  if (cleaned === '' || cleaned === '-' || cleaned === '.') return null;

  const parsed = parseFloat(cleaned);
  return isNaN(parsed) ? null : parsed;
}

export function buildPartUpsertByPartNumberVariables(part: Part | Partial<Part>): PartUpsertByPartNumberVariables {
  return {
    partNumber: part.partNumber,
    // Part.assemblyBoolean is `null` for any non-assembly part (see Part model),
    // but the schema column is NOT NULL — an explicit `null` variable violates that
    // constraint instead of falling back to the column's default.
    assemblyBoolean: part.assemblyBoolean ?? false,
    description: part.description,
    notes: part.notes,
    status: part.status,
    toolClass: part.toolClass,
    toolType: part.toolType,
    toolFamily: part.toolFamily,
    toolSeries: part.toolSeries,
    dod: numberOrNull(part.od),
    did: numberOrNull(part.id),
    drift: numberOrNull(part.drift),
    lengthClosed: numberOrNull(part.lengthClosed),
    lengthOpen: numberOrNull(part.lengthOpen),
    workingLength: numberOrNull(part.workingLength),
    overallLength: numberOrNull(part.overallLength),
    tareWeight: numberOrNull(part.weight),
    // Material (materialType/grade/weight) is no longer sent here — it's owned exclusively by
    // the dedicated, role-gated PartMaterialUpsertByPartNumber mutation (see part-container.component.ts)
    // so a Sheets-sourced dimensions save or sync can't silently overwrite an edited PartMaterial row.
    topConnection: part.topConnection,
    bottomConnection: part.bottomConnection,
  };
}
